import { defineStore } from 'pinia'
import api from '@/api'
import config from '@/config/local'

export const useUserStore = defineStore('user', {
	state: () => ({
		info: null as any
	}),

	actions: {
		update(data: any) {
			this.info = data
		},

		updateLastLesson(data: any) {
			this.info.lastLesson = data
		},

		async get() {
			const response = await api.get(config.apiHost + '/api/user/info')
			if (response.data.success) {
				this.update(response.data.data)
				return response.data.data
			}
		},

		async setLastLesson(data: any) {
			await api.post(config.apiHost + '/api/user/set-last-lesson-id', {lessonId: data.id})
			this.updateLastLesson(data)
		},

		async addEvent(data: {name: string, params: any}) {
			data.name = 'lk.' + data.name
			await api.post(config.apiHost + '/api/user/add-event', data)
		}
	}
})
